import { BATCH_SIZE, BATCH_DELAY_MS } from '../../../../utils/config';

/**
 * Split array into chunks of specified size
 */
export const chunkArray = (array, size = BATCH_SIZE) => {
  const chunks = [];
  for (let i = 0; i < array.length; i += size) {
    chunks.push(array.slice(i, i + size));
  }
  return chunks;
};

/**
 * Sleep for specified milliseconds
 */
export const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));

/**
 * Process batches concurrently with staggered starts
 * @param {Array} batches - Array of payment batches
 * @param {Function} processFn - Function to process each batch (should return Promise)
 * @param {Function} onBatchStart - Callback when batch starts
 * @param {Function} onBatchComplete - Callback when batch completes
 * @param {Number} delayMs - Delay between batch starts
 */
export const processBatchesStaggered = async (
  batches,
  processFn,
  onBatchStart,
  onBatchComplete,
  delayMs = BATCH_DELAY_MS
) => {
  const promises = batches.map(async (batch, index) => {
    // Stagger the start times
    if (index > 0) {
      await sleep(index * delayMs);
    }

    onBatchStart(index);

    try {
      const result = await processFn(batch, index);
      onBatchComplete(index, 'success', result);
      return { batchNumber: index + 1, status: 'success', result };
    } catch (error) {
      onBatchComplete(index, 'error', error);
      return { batchNumber: index + 1, status: 'error', error };
    }
  });

  // Wait for all batches to complete
  return await Promise.all(promises);
};
